var map = {
	"./af-NA/territories.json": [
		74675,
		74675
	],
	"./af/territories.json": [
		27463,
		27463
	],
	"./am/territories.json": [
		52838,
		52838
	],
	"./ar-AE/territories.json": [
		39632,
		39632
	],
	"./ar-BH/territories.json": [
		98116,
		98116
	],
	"./ar-DJ/territories.json": [
		20308,
		20308
	],
	"./ar-DZ/territories.json": [
		66884,
		66884
	],
	"./ar-EG/territories.json": [
		34490,
		34490
	],
	"./ar-EH/territories.json": [
		96919,
		96919
	],
	"./ar-ER/territories.json": [
		88093,
		88093
	],
	"./ar-IL/territories.json": [
		57815,
		57815
	],
	"./ar-IQ/territories.json": [
		87100,
		87100
	],
	"./ar-JO/territories.json": [
		12605,
		12605
	],
	"./ar-KM/territories.json": [
		33526,
		33526
	],
	"./ar-KW/territories.json": [
		448,
		448
	],
	"./ar-LB/territories.json": [
		3428,
		3428
	],
	"./ar-LY/territories.json": [
		50113,
		50113
	],
	"./ar-MA/territories.json": [
		69216,
		69216
	],
	"./ar-MR/territories.json": [
		68389,
		68389
	],
	"./ar-OM/territories.json": [
		67218,
		67218
	],
	"./ar-PS/territories.json": [
		78111,
		78111
	],
	"./ar-QA/territories.json": [
		42612,
		42612
	],
	"./ar-SA/territories.json": [
		51802,
		51802
	],
	"./ar-SD/territories.json": [
		40493,
		40493
	],
	"./ar-SO/territories.json": [
		30352,
		30352
	],
	"./ar-SS/territories.json": [
		12220,
		12220
	],
	"./ar-SY/territories.json": [
		56610,
		56610
	],
	"./ar-TD/territories.json": [
		16438,
		16438
	],
	"./ar-TN/territories.json": [
		9040,
		9040
	],
	"./ar-YE/territories.json": [
		33448,
		33448
	],
	"./ar/territories.json": [
		69275,
		69275
	],
	"./as/territories.json": [
		91012,
		91012
	],
	"./az-Latn/territories.json": [
		80187,
		80187
	],
	"./az/territories.json": [
		69795,
		69795
	],
	"./be-tarask/territories.json": [
		88008,
		88008
	],
	"./be/territories.json": [
		137,
		137
	],
	"./bg/territories.json": [
		60072,
		37691
	],
	"./bn-IN/territories.json": [
		24008,
		24008
	],
	"./bn/territories.json": [
		76652,
		76652
	],
	"./bs-Latn/territories.json": [
		8231,
		8231
	],
	"./bs/territories.json": [
		95879,
		95879
	],
	"./ca-AD/territories.json": [
		89574,
		89574
	],
	"./ca-ES-valencia/territories.json": [
		82741,
		82741
	],
	"./ca-FR/territories.json": [
		26723,
		26723
	],
	"./ca-IT/territories.json": [
		79294,
		79294
	],
	"./ca/territories.json": [
		21628,
		21628
	],
	"./chr/territories.json": [
		30763,
		30763
	],
	"./cs/territories.json": [
		36986,
		36986
	],
	"./cy/territories.json": [
		37796,
		37796
	],
	"./da-GL/territories.json": [
		29874,
		7493
	],
	"./da/territories.json": [
		14751,
		14751
	],
	"./de-AT/territories.json": [
		25391,
		25391
	],
	"./de-BE/territories.json": [
		77319,
		77319
	],
	"./de-CH/territories.json": [
		34097,
		34097
	],
	"./de-IT/territories.json": [
		29351,
		29351
	],
	"./de-LI/territories.json": [
		78073,
		78073
	],
	"./de-LU/territories.json": [
		16781,
		16781
	],
	"./de/territories.json": [
		34947,
		34947
	],
	"./dsb/territories.json": [
		54989,
		54989
	],
	"./el-CY/territories.json": [
		7632,
		7632
	],
	"./el-polyton/territories.json": [
		13435,
		13435
	],
	"./el/territories.json": [
		71609,
		71609
	],
	"./en-001/territories.json": [
		9905,
		9905
	],
	"./en-150/territories.json": [
		38040,
		38040
	],
	"./en-AE/territories.json": [
		63808,
		63808
	],
	"./en-AG/territories.json": [
		86750,
		86750
	],
	"./en-AI/territories.json": [
		97692,
		97692
	],
	"./en-AS/territories.json": [
		6738,
		6738
	],
	"./en-AT/territories.json": [
		60599,
		60599
	],
	"./en-AU/territories.json": [
		52592,
		52592
	],
	"./en-BB/territories.json": [
		28874,
		28874
	],
	"./en-BE/territories.json": [
		76879,
		76879
	],
	"./en-BI/territories.json": [
		12715,
		12715
	],
	"./en-BM/territories.json": [
		9831,
		9831
	],
	"./en-BS/territories.json": [
		75409,
		75409
	],
	"./en-BW/territories.json": [
		45325,
		45325
	],
	"./en-BZ/territories.json": [
		75506,
		75506
	],
	"./en-CA/territories.json": [
		30010,
		30010
	],
	"./en-CC/territories.json": [
		59020,
		59020
	],
	"./en-CH/territories.json": [
		82505,
		82505
	],
	"./en-CK/territories.json": [
		41796,
		41796
	],
	"./en-CM/territories.json": [
		74766,
		74766
	],
	"./en-CX/territories.json": [
		64217,
		64217
	],
	"./en-CY/territories.json": [
		60546,
		60546
	],
	"./en-DE/territories.json": [
		39917,
		39917
	],
	"./en-DG/territories.json": [
		35071,
		35071
	],
	"./en-DK/territories.json": [
		62459,
		62459
	],
	"./en-DM/territories.json": [
		97925,
		97925
	],
	"./en-ER/territories.json": [
		21242,
		98861
	],
	"./en-FI/territories.json": [
		63391,
		63391
	],
	"./en-FJ/territories.json": [
		24566,
		24566
	],
	"./en-FK/territories.json": [
		93389,
		93389
	],
	"./en-FM/territories.json": [
		2723,
		2723
	],
	"./en-GB/territories.json": [
		22343,
		22343
	],
	"./en-GD/territories.json": [
		29401,
		29401
	],
	"./en-GG/territories.json": [
		27892,
		27892
	],
	"./en-GH/territories.json": [
		10909,
		10909
	],
	"./en-GI/territories.json": [
		1702,
		1702
	],
	"./en-GM/territories.json": [
		18698,
		18698
	],
	"./en-GU/territories.json": [
		90098,
		90098
	],
	"./en-GY/territories.json": [
		30710,
		30710
	],
	"./en-HK/territories.json": [
		32767,
		32767
	],
	"./en-ID/territories.json": [
		30991,
		30991
	],
	"./en-IE/territories.json": [
		29032,
		29032
	],
	"./en-IL/territories.json": [
		55079,
		55079
	],
	"./en-IM/territories.json": [
		69472,
		69472
	],
	"./en-IN/territories.json": [
		43221,
		43221
	],
	"./en-IO/territories.json": [
		97086,
		97086
	],
	"./en-JE/territories.json": [
		13783,
		13783
	],
	"./en-JM/territories.json": [
		44351,
		44351
	],
	"./en-KE/territories.json": [
		53054,
		53054
	],
	"./en-KI/territories.json": [
		75338,
		75338
	],
	"./en-KN/territories.json": [
		23343,
		23343
	],
	"./en-KY/territories.json": [
		8058,
		8058
	],
	"./en-LC/territories.json": [
		59211,
		59211
	],
	"./en-LR/territories.json": [
		20932,
		20932
	],
	"./en-LS/territories.json": [
		40507,
		40507
	],
	"./en-MG/territories.json": [
		21330,
		21330
	],
	"./en-MH/territories.json": [
		81535,
		81535
	],
	"./en-MO/territories.json": [
		88538,
		88538
	],
	"./en-MP/territories.json": [
		53575,
		53575
	],
	"./en-MS/territories.json": [
		62110,
		62110
	],
	"./en-MT/territories.json": [
		27627,
		27627
	],
	"./en-MU/territories.json": [
		59124,
		59124
	],
	"./en-MV/territories.json": [
		60633,
		60633
	],
	"./en-MW/territories.json": [
		39042,
		39042
	],
	"./en-MY/territories.json": [
		59432,
		59432
	],
	"./en-NA/territories.json": [
		48927,
		48927
	],
	"./en-NF/territories.json": [
		99898,
		99898
	],
	"./en-NG/territories.json": [
		11857,
		11857
	],
	"./en-NL/territories.json": [
		4164,
		4164
	],
	"./en-NR/territories.json": [
		39494,
		39494
	],
	"./en-NU/territories.json": [
		87219,
		87219
	],
	"./en-NZ/territories.json": [
		81854,
		81854
	],
	"./en-PG/territories.json": [
		95779,
		95779
	],
	"./en-PH/territories.json": [
		55022,
		55022
	],
	"./en-PK/territories.json": [
		45015,
		45015
	],
	"./en-PN/territories.json": [
		83396,
		83396
	],
	"./en-PR/territories.json": [
		53480,
		53480
	],
	"./en-PW/territories.json": [
		67123,
		67123
	],
	"./en-RW/territories.json": [
		62941,
		62941
	],
	"./en-SB/territories.json": [
		82355,
		82355
	],
	"./en-SC/territories.json": [
		98812,
		98812
	],
	"./en-SD/territories.json": [
		51421,
		51421
	],
	"./en-SE/territories.json": [
		42214,
		42214
	],
	"./en-SG/territories.json": [
		68712,
		68712
	],
	"./en-SH/territories.json": [
		69913,
		69913
	],
	"./en-SI/territories.json": [
		64674,
		64674
	],
	"./en-SL/territories.json": [
		59157,
		59157
	],
	"./en-SS/territories.json": [
		31564,
		31564
	],
	"./en-SX/territories.json": [
		12745,
		12745
	],
	"./en-SZ/territories.json": [
		34555,
		34555
	],
	"./en-TC/territories.json": [
		56787,
		56787
	],
	"./en-TK/territories.json": [
		83531,
		83531
	],
	"./en-TO/territories.json": [
		78727,
		78727
	],
	"./en-TT/territories.json": [
		33846,
		33846
	],
	"./en-TV/territories.json": [
		75768,
		75768
	],
	"./en-TZ/territories.json": [
		57476,
		57476
	],
	"./en-UG/territories.json": [
		11706,
		11706
	],
	"./en-UM/territories.json": [
		25892,
		25892
	],
	"./en-VC/territories.json": [
		6037,
		6037
	],
	"./en-VG/territories.json": [
		27929,
		27929
	],
	"./en-VI/territories.json": [
		77455,
		77455
	],
	"./en-VU/territories.json": [
		66715,
		66715
	],
	"./en-WS/territories.json": [
		17056,
		17056
	],
	"./en-ZA/territories.json": [
		92811,
		92811
	],
	"./en-ZM/territories.json": [
		90479,
		90479
	],
	"./en-ZW/territories.json": [
		99813,
		99813
	],
	"./en/territories.json": [
		97912,
		75531
	],
	"./es-419/territories.json": [
		44095,
		44095
	],
	"./es-AR/territories.json": [
		41976,
		41976
	],
	"./es-BO/territories.json": [
		31312,
		31312
	],
	"./es-BR/territories.json": [
		97651,
		97651
	],
	"./es-BZ/territories.json": [
		52203,
		52203
	],
	"./es-CL/territories.json": [
		85024,
		85024
	],
	"./es-CO/territories.json": [
		89685,
		89685
	],
	"./es-CR/territories.json": [
		28346,
		28346
	],
	"./es-CU/territories.json": [
		37695,
		37695
	],
	"./es-DO/territories.json": [
		32386,
		32386
	],
	"./es-EA/territories.json": [
		46065,
		46065
	],
	"./es-EC/territories.json": [
		10947,
		10947
	],
	"./es-GQ/territories.json": [
		16839,
		16839
	],
	"./es-GT/territories.json": [
		82580,
		82580
	],
	"./es-HN/territories.json": [
		22293,
		22293
	],
	"./es-IC/territories.json": [
		22007,
		22007
	],
	"./es-MX/territories.json": [
		20282,
		20282
	],
	"./es-NI/territories.json": [
		21662,
		21662
	],
	"./es-PA/territories.json": [
		23204,
		23204
	],
	"./es-PE/territories.json": [
		40592,
		40592
	],
	"./es-PH/territories.json": [
		35587,
		35587
	],
	"./es-PR/territories.json": [
		94489,
		94489
	],
	"./es-PY/territories.json": [
		23388,
		23388
	],
	"./es-SV/territories.json": [
		73350,
		73350
	],
	"./es-US/territories.json": [
		43395,
		43395
	],
	"./es-UY/territories.json": [
		94089,
		94089
	],
	"./es-VE/territories.json": [
		94130,
		94130
	],
	"./es/territories.json": [
		84120,
		84120
	],
	"./et/territories.json": [
		39121,
		39121
	],
	"./eu/territories.json": [
		35290,
		35290
	],
	"./fa-AF/territories.json": [
		60587,
		60587
	],
	"./fa/territories.json": [
		67097,
		67097
	],
	"./fi/territories.json": [
		51521,
		51521
	],
	"./fil/territories.json": [
		78367,
		78367
	],
	"./fr-BE/territories.json": [
		7450,
		7450
	],
	"./fr-BF/territories.json": [
		92515,
		92515
	],
	"./fr-BI/territories.json": [
		2190,
		2190
	],
	"./fr-BJ/territories.json": [
		35159,
		35159
	],
	"./fr-BL/territories.json": [
		30633,
		30633
	],
	"./fr-CA/territories.json": [
		93295,
		93295
	],
	"./fr-CD/territories.json": [
		87484,
		87484
	],
	"./fr-CF/territories.json": [
		69450,
		69450
	],
	"./fr-CG/territories.json": [
		99905,
		99905
	],
	"./fr-CH/territories.json": [
		53600,
		53600
	],
	"./fr-CI/territories.json": [
		90823,
		90823
	],
	"./fr-CM/territories.json": [
		79275,
		79275
	],
	"./fr-DJ/territories.json": [
		50025,
		50025
	],
	"./fr-DZ/territories.json": [
		8441,
		8441
	],
	"./fr-GA/territories.json": [
		34091,
		34091
	],
	"./fr-GF/territories.json": [
		11614,
		11614
	],
	"./fr-GN/territories.json": [
		40230,
		40230
	],
	"./fr-GP/territories.json": [
		78404,
		78404
	],
	"./fr-GQ/territories.json": [
		73019,
		73019
	],
	"./fr-HT/territories.json": [
		39955,
		39955
	],
	"./fr-KM/territories.json": [
		403,
		403
	],
	"./fr-LU/territories.json": [
		90784,
		90784
	],
	"./fr-MA/territories.json": [
		84333,
		84333
	],
	"./fr-MC/territories.json": [
		44671,
		44671
	],
	"./fr-MF/territories.json": [
		97324,
		97324
	],
	"./fr-MG/territories.json": [
		52867,
		52867
	],
	"./fr-ML/territories.json": [
		70546,
		70546
	],
	"./fr-MQ/territories.json": [
		73725,
		73725
	],
	"./fr-MR/territories.json": [
		9544,
		9544
	],
	"./fr-MU/territories.json": [
		46401,
		46401
	],
	"./fr-NC/territories.json": [
		71292,
		71292
	],
	"./fr-NE/territories.json": [
		66822,
		66822
	],
	"./fr-PF/territories.json": [
		9513,
		9513
	],
	"./fr-PM/territories.json": [
		3276,
		3276
	],
	"./fr-RE/territories.json": [
		78154,
		78154
	],
	"./fr-RW/territories.json": [
		39884,
		39884
	],
	"./fr-SC/territories.json": [
		35661,
		35661
	],
	"./fr-SN/territories.json": [
		70610,
		70610
	],
	"./fr-SY/territories.json": [
		2855,
		2855
	],
	"./fr-TD/territories.json": [
		40079,
		40079
	],
	"./fr-TG/territories.json": [
		97446,
		97446
	],
	"./fr-TN/territories.json": [
		14389,
		14389
	],
	"./fr-VU/territories.json": [
		39726,
		39726
	],
	"./fr-WF/territories.json": [
		40654,
		40654
	],
	"./fr-YT/territories.json": [
		11078,
		11078
	],
	"./fr/territories.json": [
		21380,
		21380
	],
	"./ga-GB/territories.json": [
		8518,
		8518
	],
	"./ga/territories.json": [
		47728,
		47728
	],
	"./gd/territories.json": [
		90651,
		90651
	],
	"./gl/territories.json": [
		26403,
		26403
	],
	"./gu/territories.json": [
		91220,
		91220
	],
	"./ha-GH/territories.json": [
		5685,
		5685
	],
	"./ha-NE/territories.json": [
		19899,
		19899
	],
	"./ha/territories.json": [
		14259,
		14259
	],
	"./he/territories.json": [
		31695,
		31695
	],
	"./hi-Latn/territories.json": [
		46115,
		46115
	],
	"./hi/territories.json": [
		83883,
		83883
	],
	"./hr-BA/territories.json": [
		24308,
		24308
	],
	"./hr/territories.json": [
		58,
		58
	],
	"./hsb/territories.json": [
		28089,
		28089
	],
	"./hu/territories.json": [
		56351,
		56351
	],
	"./hy/territories.json": [
		6459,
		6459
	],
	"./id/territories.json": [
		84909,
		84909
	],
	"./ig/territories.json": [
		56984,
		56984
	],
	"./is/territories.json": [
		86684,
		86684
	],
	"./it-CH/territories.json": [
		79435,
		79435
	],
	"./it-SM/territories.json": [
		7952,
		7952
	],
	"./it-VA/territories.json": [
		32969,
		32969
	],
	"./it/territories.json": [
		44637,
		44637
	],
	"./ja/territories.json": [
		27773,
		27773
	],
	"./jv/territories.json": [
		7916,
		7916
	],
	"./ka/territories.json": [
		42676,
		42676
	],
	"./kk/territories.json": [
		34474,
		34474
	],
	"./km/territories.json": [
		42312,
		42312
	],
	"./kn/territories.json": [
		92477,
		92477
	],
	"./ko-CN/territories.json": [
		28920,
		28920
	],
	"./ko-KP/territories.json": [
		40570,
		40570
	],
	"./ko/territories.json": [
		49766,
		49766
	],
	"./kok/territories.json": [
		34315,
		34315
	],
	"./ky/territories.json": [
		20876,
		20876
	],
	"./lo/territories.json": [
		76305,
		76305
	],
	"./lt/territories.json": [
		11092,
		11092
	],
	"./lv/territories.json": [
		48258,
		48258
	],
	"./mk/territories.json": [
		68200,
		68200
	],
	"./ml/territories.json": [
		88705,
		88705
	],
	"./mn/territories.json": [
		41619,
		41619
	],
	"./mr/territories.json": [
		59671,
		59671
	],
	"./ms-BN/territories.json": [
		21151,
		21151
	],
	"./ms-ID/territories.json": [
		74650,
		74650
	],
	"./ms-SG/territories.json": [
		7013,
		7013
	],
	"./ms/territories.json": [
		16496,
		16496
	],
	"./my/territories.json": [
		71862,
		71862
	],
	"./nb-SJ/territories.json": [
		63270,
		63270
	],
	"./nb/territories.json": [
		24396,
		24396
	],
	"./ne-IN/territories.json": [
		63527,
		63527
	],
	"./ne/territories.json": [
		11405,
		11405
	],
	"./nl-AW/territories.json": [
		62265,
		62265
	],
	"./nl-BE/territories.json": [
		1916,
		1916
	],
	"./nl-BQ/territories.json": [
		49176,
		49176
	],
	"./nl-CW/territories.json": [
		31887,
		31887
	],
	"./nl-SR/territories.json": [
		23244,
		23244
	],
	"./nl-SX/territories.json": [
		96466,
		96466
	],
	"./nl/territories.json": [
		98958,
		98958
	],
	"./nn/territories.json": [
		1264,
		1264
	],
	"./no/territories.json": [
		28087,
		28087
	],
	"./or/territories.json": [
		53677,
		53677
	],
	"./pa-Guru/territories.json": [
		74051,
		74051
	],
	"./pa/territories.json": [
		47627,
		47627
	],
	"./pl/territories.json": [
		45640,
		45640
	],
	"./ps-PK/territories.json": [
		21933,
		21933
	],
	"./ps/territories.json": [
		14217,
		14217
	],
	"./pt-AO/territories.json": [
		45683,
		45683
	],
	"./pt-CH/territories.json": [
		1532,
		1532
	],
	"./pt-CV/territories.json": [
		47822,
		47822
	],
	"./pt-GQ/territories.json": [
		42559,
		42559
	],
	"./pt-GW/territories.json": [
		32785,
		32785
	],
	"./pt-LU/territories.json": [
		60668,
		60668
	],
	"./pt-MO/territories.json": [
		95591,
		95591
	],
	"./pt-MZ/territories.json": [
		57988,
		57988
	],
	"./pt-PT/territories.json": [
		81023,
		81023
	],
	"./pt-ST/territories.json": [
		8544,
		8544
	],
	"./pt-TL/territories.json": [
		18595,
		18595
	],
	"./pt/territories.json": [
		10736,
		10736
	],
	"./ro-MD/territories.json": [
		819,
		819
	],
	"./ro/territories.json": [
		44947,
		44947
	],
	"./ru-BY/territories.json": [
		9673,
		9673
	],
	"./ru-KG/territories.json": [
		53026,
		53026
	],
	"./ru-KZ/territories.json": [
		36909,
		36909
	],
	"./ru-MD/territories.json": [
		54181,
		54181
	],
	"./ru-UA/territories.json": [
		12346,
		12346
	],
	"./ru/territories.json": [
		49193,
		49193
	],
	"./sd-Arab/territories.json": [
		63902,
		63902
	],
	"./sd/territories.json": [
		91423,
		91423
	],
	"./si/territories.json": [
		46660,
		46660
	],
	"./sk/territories.json": [
		946,
		946
	],
	"./sl/territories.json": [
		31415,
		31415
	],
	"./so-DJ/territories.json": [
		64539,
		64539
	],
	"./so-ET/territories.json": [
		7640,
		7640
	],
	"./so-KE/territories.json": [
		19989,
		19989
	],
	"./so/territories.json": [
		2286,
		2286
	],
	"./sq-MK/territories.json": [
		56047,
		56047
	],
	"./sq-XK/territories.json": [
		86678,
		86678
	],
	"./sq/territories.json": [
		86460,
		86460
	],
	"./sr-Cyrl-BA/territories.json": [
		12640,
		12640
	],
	"./sr-Cyrl-ME/territories.json": [
		50079,
		50079
	],
	"./sr-Cyrl-XK/territories.json": [
		62696,
		62696
	],
	"./sr-Cyrl/territories.json": [
		18918,
		18918
	],
	"./sr-Latn-BA/territories.json": [
		68561,
		68561
	],
	"./sr-Latn-ME/territories.json": [
		68286,
		68286
	],
	"./sr-Latn-XK/territories.json": [
		8469,
		8469
	],
	"./sr-Latn/territories.json": [
		37753,
		37753
	],
	"./sr/territories.json": [
		76801,
		76801
	],
	"./sv-AX/territories.json": [
		1457,
		1457
	],
	"./sv-FI/territories.json": [
		30721,
		30721
	],
	"./sv/territories.json": [
		4125,
		4125
	],
	"./sw-CD/territories.json": [
		41038,
		41038
	],
	"./sw-KE/territories.json": [
		70973,
		70973
	],
	"./sw-UG/territories.json": [
		62821,
		62821
	],
	"./sw/territories.json": [
		81990,
		81990
	],
	"./ta-LK/territories.json": [
		71855,
		71855
	],
	"./ta-MY/territories.json": [
		87060,
		87060
	],
	"./ta-SG/territories.json": [
		98964,
		98964
	],
	"./ta/territories.json": [
		72207,
		72207
	],
	"./te/territories.json": [
		54771,
		54771
	],
	"./th/territories.json": [
		35776,
		35776
	],
	"./tk/territories.json": [
		46581,
		46581
	],
	"./tr-CY/territories.json": [
		18481,
		18481
	],
	"./tr/territories.json": [
		91446,
		91446
	],
	"./uk/territories.json": [
		52464,
		52464
	],
	"./ur-IN/territories.json": [
		94689,
		94689
	],
	"./ur/territories.json": [
		56975,
		56975
	],
	"./uz-Latn/territories.json": [
		93799,
		93799
	],
	"./uz/territories.json": [
		89927,
		89927
	],
	"./vi/territories.json": [
		91761,
		91761
	],
	"./yo-BJ/territories.json": [
		85459,
		85459
	],
	"./yo/territories.json": [
		49152,
		49152
	],
	"./yue-Hans/territories.json": [
		36088,
		36088
	],
	"./yue-Hant/territories.json": [
		48561,
		48561
	],
	"./yue/territories.json": [
		97293,
		97293
	],
	"./zh-Hans-HK/territories.json": [
		201,
		201
	],
	"./zh-Hans-MO/territories.json": [
		47564,
		47564
	],
	"./zh-Hans-SG/territories.json": [
		45222,
		45222
	],
	"./zh-Hans/territories.json": [
		18029,
		18029
	],
	"./zh-Hant-HK/territories.json": [
		58582,
		58582
	],
	"./zh-Hant-MO/territories.json": [
		35747,
		35747
	],
	"./zh-Hant/territories.json": [
		63308,
		63308
	],
	"./zh/territories.json": [
		55822,
		55822
	],
	"./zu/territories.json": [
		13985,
		13985
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 24850;
module.exports = webpackAsyncContext;